/**
 * =====================================================================
 *  SITE CONTENT CONFIG
 * =====================================================================
 *  Every piece of text on the website lives here. Edit this file only —
 *  no need to touch any component/page code to update copy.
 *  Images are configured separately in `src/config/images.js`.
 * =====================================================================
 */

const siteContent = {
  brand: {
    name: "APKANZ",
    fullName: "Andhra Pradesh Kiwis Association New Zealand",
    tagline: "Andhra Roots \u2022 Kiwi Spirit",
  },

  vision: {
    heading: "Rooted in Andhra \u2014 United in Aotearoa",
    statement:
      "To build a vibrant, inclusive, and Andhra Pradesh community across New Zealand by honouring our roots, embracing our future, and preserving our rich cultural heritage. We strive to create a community where every family from Andhra Pradesh feels connected, valued, and inspired to thrive. Through leadership, community service, education, cultural excellence, and meaningful partnerships, we aim to empower future generations, strengthen the enduring bond between Andhra Pradesh and Aotearoa, and leave a lasting legacy of unity, pride, opportunity, and belonging for generations to come. " ,
  },

  nav: [
    { label: "Home", path: "/" },
    { label: "About Us", path: "/about" },
    // { label: "Committee", path: "/members" },
    // { label: "Events", path: "/events" },
    // { label: "Gallery", path: "/gallery" },
    { label: "Contact", path: "/contact" },
  ],

  home: {
    heroTitle: "Andhra Pradesh Kiwis Association New Zealand",
    heroTagline: "Andhra Roots \u2022 Kiwi Spirit",
    heroSubtext:
      "A home away from home for every Andhra family across Aotearoa celebrating culture, building community, and empowering generations.",
    ctaPrimary: { label: "Join Our Community", path: "/contact" },
    ctaSecondary: { label: "Meet the Committee", path: "/members" },

    // Homepage hero carousel slides. Add, remove, or reorder slides here —
    // the `image` value is a lookup key resolved in src/config/images.js
    // (heroSlideImages map), so you don't need real file paths here.
    heroSlides: [
      {
        id: 1,
        image: "slide-temple.jpg",
        eyebrow: "Andhra Roots \u2022 Kiwi Spirit",
        title: "Andhra Pradesh Kiwis Association New Zealand",
        text: "A home away from home for every Andhra family across Aotearoa.",
      },
      {
        id: 2,
        image: "slide-festival.jpg",
        eyebrow: "Celebrating Together",
        title: "Festivals, Food & Community Spirit",
        text: "From festivals, we bring the warmth of Andhra celebrations to New Zealand.",
      },
      {
        id: 3,
        image: "slide-youth.jpg",
        eyebrow: "Empowering the Next Generation",
        title: "Investing in Youth & Education",
        text: "Mentorship, leadership programs, and cultural education for young Kiwi-Andhras.",
      },
      {
        id: 4,
        image: "slide-nz.jpg",
        eyebrow: "Bridging Two Homes",
        title: "Rooted in Andhra, United in Aotearoa",
        text: "Strengthening the enduring bond between Andhra Pradesh and New Zealand.",
      },
    ],

    // Secondary photo carousel shown below the hero, showcasing community
    // moments. Add/remove/reorder here - `image` is a lookup key resolved
    // in src/config/images.js (momentsCarouselImageMap).
    momentsCarousel: [
      { id: 1, image: "moment-1.jpg", caption: "" },
      { id: 2, image: "moment-2.jpg", caption: "" },
      { id: 3, image: "moment-3.jpg", caption: "" },
      { id: 4, image: "moment-4.jpg", caption: "" },
      { id: 5, image: "moment-5.jpg", caption: "" },
    ],

    highlights: [
      {
        icon: "bi-people-fill",
        title: "Community First",
        text: "Connecting Andhra families across New Zealand through friendship, support, and shared celebration.",
      },
      {
        icon: "bi-mortarboard-fill",
        title: "Education & Youth",
        text: "Nurturing the next generation with cultural education, mentorship, and leadership opportunities.",
      },
      {
        icon: "bi-flower3",
        title: "Cultural Heritage",
        text: "Preserving Andhra traditions, language, festivals, and art forms for generations to come.",
      },
      {
        icon: "bi-globe-asia-australia",
        title: "Bridging Two Homes",
        text: "Strengthening the enduring bond between Andhra Pradesh and Aotearoa New Zealand.",
      },
    ],

    stateSymbols: {
      heading: "A Proud Andhra Identity",
      text: "APKANZ carries the spirit of Andhra Pradesh with us \u2014 from the Indian Roller, our state bird, to the Ongole Bull, our state animal, and the timeless architecture of temples.",
      items: [
        { label: "State Bird", value: "Rama Chiluka/Rose-ringed Parakeet" },
        { label: "State Animal", value: "Krishna Jinka/Blackbuck" },
        { label: "Heritage", value: "Temples & Traditions" },
      ],
    },

    events: {
    title: "Events & Celebrations",
    subtitle:
      "From Ugadi to Sankranti, APKANZ brings the community together to celebrate the festivals and milestones that matter most.",
    list: [
      {
        id: 1,
        title: "Ugadi Celebrations",
        date: "March 2027",
        location: "Auckland, NZ",
        description:
          "Ring in the Telugu New Year with traditional Ugadi Pachadi, cultural performances, and community feasting.",
        image: "event-ugadi.jpg",
      },
      {
        id: 2,
        title: "Sankranti Festival",
        date: "January 2027",
        location: "Wellington, NZ",
        description:
          "A vibrant harvest festival featuring kite flying, folk dances, and traditional Andhra cuisine.",
        image: "event-sankranti.jpg",
      },
      {
        id: 3,
        title: "APKANZ Annual Gala",
        date: "November 2026",
        location: "Hamilton, NZ",
        description:
          "Our flagship annual event celebrating community achievements with awards, dinner, and entertainment.",
        image: "event-gala.jpg",
      },
      {
        id: 4,
        title: "Youth Leadership Camp",
        date: "July 2026",
        location: "Christchurch, NZ",
        description:
          "A weekend of workshops and mentorship empowering the next generation of Kiwi-Andhra leaders.",
        image: "event-youth.jpg",
      },
    ],
    },

  },

  sponsors: {
    heading: "Our Sponsors & Partners",
    subtitle:
      "APKANZ is proud to be supported by organisations who share our commitment to community, culture, and connection.",
    // Add/remove sponsors here. `logo` is a lookup key resolved in
    // src/config/images.js (sponsorLogo map). `url` is optional.
    list: [
      { id: 1, name: "Sponsor One", logo: "sponsor-1.png", url: "" },
      { id: 2, name: "Sponsor Two", logo: "sponsor-2.png", url: "" },
      { id: 3, name: "Sponsor Three", logo: "sponsor-3.png", url: "" },
      { id: 4, name: "Sponsor Four", logo: "sponsor-4.png", url: "" },
      { id: 5, name: "Sponsor Five", logo: "sponsor-5.png", url: "" },
      { id: 6, name: "Sponsor Six", logo: "sponsor-6.png", url: "" },
    ],
  },

  about: {
    title: "About APKANZ",
    intro:
      "The Andhra Pradesh Kiwis Association New Zealand (APKANZ) is a community organisation dedicated to uniting people with roots in Andhra Pradesh who now call New Zealand home.",
    mission: {
      heading: "Our Mission",
      text: "To foster a strong, connected, and culturally vibrant Andhra Pradesh community in New Zealand supporting new migrants, celebrating our heritage, and building lasting partnerships between Andhra Pradesh and Aotearoa.",
    },
    values: [
      {
        icon: "bi-heart-fill",
        title: "Unity",
        text: "Bringing every Andhra family together, regardless of where in Aotearoa, New Zealand they live.",
      },
      {
        icon: "bi-shield-check",
        title: "Integrity",
        text: "Operating with transparency, accountability, and respect in everything we do.",
      },
      {
        icon: "bi-stars",
        title: "Excellence",
        text: "Striving for the highest standard in every event, initiative, and partnership.",
      },
      {
        icon: "bi-hand-thumbs-up-fill",
        title: "Service",
        text: "Committing our time and resources to support our community and wider society.",
      },
    ],
    history:
      "Founded by a group of passionate Andhra families in New Zealand, APKANZ began as a small gathering of friends celebrating festivals together. Today it has grown into a recognised association serving hundreds of families organising cultural festivals, educational programs, and community welfare initiatives across the country.",
  },

  members: {
    title: "Our Committee",
    subtitle:
      "Meet the dedicated volunteers leading APKANZ a team of passionate community members working to bring our vision to life.",
    // Each member object drives the Members page & MemberCard component via props.
    // Update name / role / bio / image / socials here only.
    list: [
      {
        id: 1,
        name: "Bujje Babu Nelluri",
        role: "President",
        bio: "",
        image: "president.jpg",
        email: "",
        linkedin: "",
      },
      // {
      //   id: 2,
      //   name: "Lorem Ipsum",
      //   role: "Vice President",
      //   bio: "",
      //   image: "vice-president.jpg",
      //   email: "",
      //   linkedin: "",
      // },
      // {
      //   id: 3,
      //   name: "Lorem Ipsum",
      //   role: "General Secretary",
      //   bio: "",
      //   image: "general-secretary.jpg",
      //   email: "",
      //   linkedin: "",
      // },
      {
        id: 4,
        name: "Guru Sai Sushwanth Konigeti",
        role: "Secretary",
        bio: "",
        image: "secretary.jpg",
        email: "",
        linkedin: "",
      },
      // {
      //   id: 5,
      //   name: "Rajasimha Reddy Vutukur",
      //   role: "Treasurer",
      //   bio: "",
      //   image: "treasurer.jpg",
      //   email: "",
      //   linkedin: "",
      // },
      {
        id: 5,
        name: "Aravinda Singavarapu",
        role: "Treasurer",
        bio: "",
        image: "aravinda-ec.jpg",
        email: "",
        linkedin: "",
      },
      {
        id: 6,
        name: "Pramod Eerugu",
        role: "Executive Committee Memeber",
        bio: "",
        image: "pramod-ec.jpg",
        email: "",
        linkedin: "",
      },
      {
        id: 7,
        name: "Lokesh Vemuri",
        role: "Executive Committee Memeber",
        bio: "",
        image: "lokesh-ec.jpg",
        email: "",
        linkedin: "",
      },
      // {
      //   id: 8,
      //   name: "Aravinda Singavarapu",
      //   role: "Executive Committee Memeber",
      //   bio: "",
      //   image: "aravinda-ec.jpg",
      //   email: "",
      //   linkedin: "",
      // },
      // {
      //   id: 8,
      //   name: "Adiseshaiah Nallapaneni",
      //   role: "Executive Committee Memeber",
      //   bio: "",
      //   image: "adiseshaiah-ec.jpg",
      //   email: "",
      //   linkedin: "",
      // },
      {
        id: 9,
        name: "Karthik Subramani Gendikotta",
        role: "Executive Committee Memeber",
        bio: "",
        image: "karthik-ec.jpg",
        email: "",
        linkedin: "",
      },
      {
        id: 10,
        name: "Laxmanrao Jommala",
        role: "Executive Committee Memeber",
        bio: "",
        image: "Laxmanrao-ec.jpg",
        email: "",
        linkedin: "",
      },
    ],
  },

  events: {
    title: "Events & Celebrations",
    subtitle:
      "From Ugadi to Sankranti, APKANZ brings the community together to celebrate the festivals and milestones that matter most.",
    list: [
      {
        id: 1,
        title: "APKANZ Annual Gala",
        date: "November 2026",
        location: "Hamilton, NZ",
        description:
          "Our flagship annual event celebrating community achievements with awards, dinner, and entertainment.",
        image: "event-gala.jpg",
      },
      {
        id: 2,
        title: "Youth Leadership Camp",
        date: "July 2026",
        location: "Christchurch, NZ",
        description:
          "A weekend of workshops and mentorship empowering the next generation of Kiwi-Andhra leaders.",
        image: "event-youth.jpg",
      },
    ],
  },

  gallery: {
    title: "Gallery",
    subtitle: "Moments from our community celebrations, events, and milestones.",
    // Replace file names with your own images placed in src/assets/gallery/
    images: [
      { src: "gallery-1.jpg", alt: "APKANZ community gathering" },
      { src: "gallery-2.jpg", alt: "Cultural dance performance" },
      { src: "gallery-3.jpg", alt: "Ugadi festival celebration" },
      { src: "gallery-4.jpg", alt: "Youth leadership camp" },
      { src: "gallery-5.jpg", alt: "Annual gala dinner" },
      { src: "gallery-6.jpg", alt: "Committee community service" },
    ],
  },

  contact: {
    title: "Get In Touch",
    subtitle:
      "Have a question, want to volunteer, or interested in joining APKANZ? We'd love to hear from you.",
    name: "Bujje Babu Nelluri",
    role: "Founder President",
    address: "5 Vigour Lane Papakura Auckland 2110",
    email: "bujjebabunelluri@gmail.com",
    phone: "+0223795469",
    social: {
      facebook: "https://facebook.com/apkanz",
      instagram: "https://instagram.com/apkanz",
      linkedin: "https://linkedin.com/company/apkanz",
    },
  },

  footer: {
    copyright: `\u00A9 ${new Date().getFullYear()} Andhra Pradesh Kiwis Association New Zealand (APKANZ). All rights reserved.`,
    tagline: "Rooted in Andhra \u2022 United in Aotearoa",
  },
};

export default siteContent;
